import MapGL, {
  GeolocateControl,
  Marker,
  NavigationControl,
} from '@urbica/react-map-gl';
import { useRef, useEffect, useState } from 'react';
import useSWRMutation from 'swr';

import { urls } from '../../urls';

export const TransferMap = ({ transfer, isVisible }) => {
  if (transfer?.pickUp?.location == null || transfer?.dropOff?.location == {})
    return null;
  const mapReference = useRef();
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    data: tracking,
    error: trackingErrror,
    isMutating: trackingIsLoading,
    mutate: trackingUpdate,
  } = useSWRMutation(urls.api.tracking + transfer?.distributorCode, (url) =>
    fetch(url)
      .then((res) => res.json())
      .catch((err) => console.error(err)),
  );

  useEffect(() => {
    const initialize = async () => {
      setTimeout(initializeMap, 1000); // wait a second to give the map time to initialize
    };

    if (isVisible && !isInitialized) {
      const interval = setInterval(async () => {
        trackingUpdate();
      }, 30000);

      setIsInitialized(true);
      initialize();

      // on Unmount
      return () => {
        setIsInitialized(false);
        clearInterval(interval);
      };
    } else if (!isVisible && isInitialized) {
      setIsInitialized(false);
    }
  }, [isVisible]);

  const initializeMap = () => {
    const map = mapReference?.current?.getMap();
    try {
      // clear old route
      if (map) {
        if (map.getLayer('route')) {
          map.removeLayer('route');
        }
        if (map.getSource('route')) {
          map.removeSource('route');
        }

        // add new route
        const coordinates =
          transfer?.route
            .filter(
              (location) =>
                location.location.longitude !== -1 &&
                location.location.latitude !== -1,
            )
            .map((location) => [
              location.location.longitude,
              location.location.latitude,
            ]) ?? [];
        if (coordinates.length) {
          map?.addSource('route', {
            type: 'geojson',
            data: {
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'LineString',
                coordinates,
              },
            },
          });
          map?.addLayer({
            id: 'route',
            type: 'line',
            source: 'route',
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#41a000',
              'line-width': 8,
            },
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const mapboxProps = {
    accessToken:
      'pk.eyJ1IjoiYmVudG91cml0IiwiYSI6ImNsNzRvM21wNjA2eDczbnA2cHUzNjg3N3YifQ.v1cVdHFuoEmY8Bfid-UMOA',
    latitude: transfer?.pickUp?.location?.latitude,
    longitude: transfer?.pickUp?.location?.longitude,
    zoom: 8,
  };

  return (
    <MapGL
      style={{ width: '100%', height: '70vh', borderRadius: '6px' }}
      mapStyle="mapbox://styles/bentourit/cl7fxckxn000n15s01yc4c6o9"
      ref={mapReference}
      {...mapboxProps}
      onViewportChange={() => {}} // enable drag and zoom
      attributionControl={false}
    >
      {transfer?.meetingPoint && (
        <Marker
          longitude={transfer?.meetingPoint?.location?.longitude}
          latitude={transfer?.meetingPoint?.location?.latitude}
        >
          <div
            style={{
              padding: '6px',
              background: '#881467',
              borderRadius: '16px',
            }}
          >
            <div className="icon icon-mapdot text-2xl text-white" />
          </div>
        </Marker>
      )}
      <Marker
        longitude={transfer?.pickUp?.location?.longitude}
        latitude={transfer?.pickUp?.location?.latitude}
      >
        <div
          style={{
            padding: '6px',
            background: '#881467',
            borderRadius: '16px',
          }}
        >
          <div className="icon icon-hotel text-2xl text-white" />
        </div>
      </Marker>

      <Marker
        longitude={transfer?.dropOff?.location?.longitude}
        latitude={transfer?.dropOff?.location?.latitude}
      >
        <div
          style={{
            padding: '6px',
            background: '#881467',
            borderRadius: '16px',
          }}
        >
          <div className="icon icon-plane text-2xl text-white" />
        </div>
      </Marker>

      {tracking?.location?.latitude && (
        <Marker
          longitude={tracking?.location?.longitude}
          latitude={tracking?.location?.latitude}
        >
          <div
            style={{
              padding: '6px',
              background: '#41a000',
              borderRadius: '16px',
            }}
          >
            <div className="icon icon-bus text-2xl text-white" />
          </div>
        </Marker>
      )}
      <NavigationControl
        showCompass={true}
        showZoom={true}
        position="bottom-right"
      />
      <GeolocateControl
        position="bottom-left"
        positionOptions={{ enableHighAccuracy: true, timeout: 6000 }}
        onGeolocate={(event) => {
          const { longitude, latitude } = event.coords;
        }}
      />
    </MapGL>
  );
};
